/**
* Location Information JS
* -----------------------------------------------------------------------------
*
* All the JS for the Location Information component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'location-information',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.location-information' ).each( function( key, component ) {
        if ( $( component ).find( 'ul li:first-child button' ).length ) {
          $( component ).find( '.magic-line' ).css( {
            width: $( component ).find( 'ul li:first-child button' ).width(),
            left: $( component ).find( 'ul li:first-child button' ).position().left,
          } );

          $( component ).find( 'ul button' ).on( 'toggleAfter', function( event ) {
            $( component ).find( '.mobile-location-trigger span' ).text( $( event.target ).text() );
            $( component ).find( '.magic-line' ).css( {
              width: $( event.target ).width(),
              left: $( event.target ).position().left,
            } );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'location-information', COMPONENT );
} )( app );
